import React from 'react'
import {about, algarve, centro, douro, card1, card2, card3, card4, p1, p2, p3, p4, p5, p6, quote, h1, h2, h3, h4, h5} from '../../assets/cloudinaryUrls.js';
import { Link } from 'react-router-dom';
import './index.scss';
import Carousel from 'react-multi-carousel';
import { FormattedMessage } from 'react-intl';



function About() {


  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1
    },
    biggerdesktop: {
      breakpoint: { max: 3000, min: 1800 },
      items: 1
    },
    desktop: {
      breakpoint: { max: 1800, min: 1024 },
      items: 1
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
      
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
  
    }
  };








  return (
    <div>
      <div className='about-banner'>
        <div className='img-wrapper'>
          <div className='img-text about'>
            <h6><FormattedMessage id="about.banner.title" /></h6>
            <h4><FormattedMessage id="about.banner.subtitle" /></h4>
          </div>
          <img src={about} alt='na' className='about-img anim' />
        </div>
      </div>
      <div className='about-us '>
        <div className='about-block flex-row div-prop'>
          <h4><FormattedMessage id="about.about_us.title" /></h4>
          <div className='right-b flex-row'>
            <p><FormattedMessage id="about.about_us.description1" /></p>
            <p><FormattedMessage id="about.about_us.description2" /></p>
          </div>
        </div>
      </div>
      <div className='what-we-do flex-row div-prop'>
        <div className='text-flex wwd' id="b">
          <h4><FormattedMessage id="about.what_we_do.title" /></h4>
          <p><FormattedMessage id="about.what_we_do.description" /></p>
        </div>
        <div className='port-imgs flex-row' id="a">
          <img src={algarve} alt='na' className='port-img one anim' /> 
          <img src={centro} alt='na' className='port-img two anim' /> 
          <img src={douro} alt='na' className='port-img three anim' /> 
        </div>
      </div>
      <div className='work-with-us div-prop'>
        <h4><FormattedMessage id="about.why_work_with_us.title" /></h4>
        
        <div className='carr'>
          <Carousel 
            swipeable={true}
            draggable={false}
            responsive={responsive}
            infinite={true} 
            customTransition={"fadeIn .5s"}
          >
            <div className='card-block div-prop flex-row'>
              <div className='flex-row card-about'>
                <img src={card1} alt='na' className='c-one' />
                <img src={card2} alt='na' className='c-two' />
                <img src={card3} alt='na' className='c-three' />
                <img src={card4} alt='na' className='c-four' />
              </div>
              <div className='flex-clmn prgp '>
                <h6><FormattedMessage id="about.why_work_with_us.expertise.title" /></h6>
                <p><FormattedMessage id="about.why_work_with_us.expertise.description" /></p>
              </div>
            </div>

            <div className='card-block div-prop flex-row'>
              <div className='flex-row card-about'>
                <img src={card2} alt='na' className='c-one anim ' />
                <img src={card4} alt='na' className='c-two anim' />
                <img src={card1} alt='na' className='c-three anim' />
                <img src={card3} alt='na' className='c-four anim' />
              </div>
              <div className='flex-clmn prgp '>
                <h6><FormattedMessage id="about.why_work_with_us.selection.title" /></h6>
                <p><FormattedMessage id="about.why_work_with_us.selection.description" /></p>
              </div>
            </div>

            <div className='card-block div-prop flex-row'>
              <div className='flex-row card-about'>
                <img src={card4} alt='na' className='c-one anim ' />
                <img src={card3} alt='na' className='c-two anim' />
                <img src={card2} alt='na' className='c-three anim' />
                <img src={card1} alt='na' className='c-four anim' />
              </div>
              <div className='flex-clmn prgp '>
                <h6><FormattedMessage id="about.why_work_with_us.reach.title" /></h6>
                <p><FormattedMessage id="about.why_work_with_us.reach.description" /></p>
              </div>
            </div>

            <div className='card-block div-prop flex-row'>
              <div className='flex-row card-about'>
                <img src={card3} alt='na' className='c-one anim ' />
                <img src={card1} alt='na' className='c-two anim' />
                <img src={card4} alt='na' className='c-three anim' />
                <img src={card2} alt='na' className='c-four anim' />
              </div>
              <div className='flex-clmn prgp '>
                <h6><FormattedMessage id="about.why_work_with_us.personalized_service.title" /></h6>
                <p><FormattedMessage id="about.why_work_with_us.personalized_service.description" /></p>
              </div>
            </div>
          </Carousel>
        </div>
      </div>
      <div className='partns-block'>
        <div className=' partns div-prop'>
          <img src={p1} alt='na' className='partn-img anim' />
          <img src={p2} alt='na' className='partn-img anim' />
          <img src={p3} alt='na' className='partn-img anim' />
          <img src={p4} alt='na' className='partn-img anim' />
          <img src={p5} alt='na' className='partn-img anim' />
          <img src={p6} alt='na' className='partn-img anim' />
        </div>
      </div>
      <div className='quote-block'>
        <div className='quote-text flex-row div-prop'>
          <div className='quote-author flex-clmn'>
            <h5><b><FormattedMessage id="about.quote.author" /></b></h5>
            <h6><FormattedMessage id="about.quote.author_title" /></h6>
          </div>
          <div className='flex-row quote'>
            <img src={quote} alt='na' className='icon-quote anim' /> 
            <p><i><FormattedMessage id="about.quote.text" /></i></p>
          </div>
        </div>
        
      </div>
      <div className='start-block'>
        <div className='content div-prop'>
          <div className='headline flex-clmn div-prop'>
            <h5><FormattedMessage id="about.getting_started.title" /></h5>
            <div className='line'></div>
          </div>
          <div className='start-imgs flex-row '>
            <div className='flex-clmn half-imgs'>
              <img src={h2} alt='na' className='half-img anim' />
              <img src={h1} alt='na' className='half-img anim' />
            </div>
            <img src={h3} alt='na' className='full-img anim' />
            <div className='flex-clmn half-imgs'>
              <img src={h5} alt='na' className='half-img anim img-hide' />
              <img src={h4} alt='na' className='half-img anim img-hide' />
            </div>
          </div>
          <div className='div-prop'>
            <Link to="#" className='start-button anim-btn prop-btn'>
              <FormattedMessage id="about.getting_started.subtitle" />
            </Link>          
          </div>
        </div>
      </div>
    </div>
  );
}

export default About